if (!customElements.get('sticky-add-to-cart')) {
  /* Compact layout for the sticky add-to-cart bar.

     The theme's own rule sets .sticky-atc__product-form to flex: 1 1 100%,
     which pushes the button onto a second row and makes the bar about 132px
     tall. Keeping everything on one line, and shrinking the thumbnail from
     4rem to 2.5rem, brings it down to roughly half that (~68px). */
  var STICKY_ATC_CSS = [
    '.sticky-atc{flex-wrap:nowrap;gap:var(--space-2xs);padding-block:var(--space-3xs);}',
    '.sticky-atc__info{min-inline-size:0;}',
    '.sticky-atc__content{min-inline-size:0;}',
    '.sticky-atc__image{max-block-size:2.5rem;}',
    '.sticky-atc__title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
    '.sticky-atc__product-form{flex:0 1 auto;inline-size:auto;}',
    '.sticky-atc__product-form .button{white-space:nowrap;}',
    '@media (max-width:749px){.sticky-atc__rating{display:none;}.sticky-atc__image{max-block-size:2.25rem;}}'
  ].join('');

  function injectStickyAtcStyles() {
    if (document.getElementById('sticky-atc-compact-styles')) return;
    var style = document.createElement('style');
    style.id = 'sticky-atc-compact-styles';
    style.appendChild(document.createTextNode(STICKY_ATC_CSS));
    document.head.appendChild(style);
  }

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      injectStickyAtcStyles();

      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      if (!this.section) return;
      this.productForm = this.section.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.variantPicker = this.section.querySelector(`variant-picker[data-section="${this.sectionId}"]`);
      if (!this.productForm) return;

      /* Show the sticky bar whenever the in-page add-to-cart form is out of
         view, and hide it when the form is visible.

         This previously also required the visitor to be scrolling downwards.
         Because the scroll-direction flag starts out false, the bar never
         appeared for anyone who landed on the page and did not scroll - and on
         mobile the buy box sits below the fold, so those visitors saw no
         add-to-cart button at all. */
      this.update();

      this.observer = new IntersectionObserver(([entry]) => {
        this.setActiveState(entry.isIntersecting);
      });
      this.observer.observe(this.productForm);

      /* Scroll and resize back the observer up in case its callback is delayed.
         Both paths compute the same thing; the throttle keeps the measurement
         to at most once every 100ms. */
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
    }

    onScroll() {
      var now = Date.now();
      if (this.lastCheck && now - this.lastCheck < 100) return;
      this.lastCheck = now;
      this.update();
    }

    update() {
      this.setActiveState(this.isFormInViewport());
    }

    /* Worked out from geometry rather than waiting for the observer's first
       callback. Without this the bar can be missing for exactly the visitor it
       is meant to serve: someone who lands on the page and never scrolls. */
    isFormInViewport() {
      var rect = this.productForm.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 0 && rect.top < viewportHeight;
    }

    setActiveState(formIsVisible) {
      if (formIsVisible) {
        this.classList.remove('sticky-atc--active');
      } else {
        this.classList.add('sticky-atc--active');
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
